export const PermissionNames = {
  AppAccess: {
    WorkerPortalAdmin: 'AppAccess.WorkerPortalAdmin',
    WorkerPortalWorker: 'AppAccess.WorkerPortalWorker',
  },
  Projects: {
    View: 'Projects.ViewAccess',
  },
  Workers: {
    Manage: 'Workers.Manage',
  },
  WorkerCertifications: {
    Manage: 'WorkerCertifications.Manage',
  },
};
